const LOG_PREFIX = "🌈 Beam:";

// This may eventually log output to Beam servers, control log verbosity, etc.
// For now it is an alias of the default JS console
export const logger = {
  error: (...args: any[]) => console.error(LOG_PREFIX, ...args),
  log: (...args: any[]) => console.log(LOG_PREFIX, ...args),
  warn: (...args: any[]) => console.warn(LOG_PREFIX, ...args),
  debug: (...args: any[]) => console.debug(LOG_PREFIX, ...args),
};
